export const LinaConstants = {
  inactivityLimit: 60,
  passwordStrength: 60,
  tableRowLimitList: [10, 20, 50, 100, 250],
  linaIcons: {
    'Mac': 'laptop_mac',
    'Pc': 'laptop_mac',
    'Chromebook': 'laptop_mac',
    'Ipad': 'tablet_mac',
    'Tablet': 'tablet_android',
    'Iphone': 'phone_iphone',
    'Phone': 'phone_iphone',
    'AppleWatch': 'watch',
    'Watch': 'watch'
  },
  blockedBrowsers: {
    'chrome': 40,
    'firefox': 36,
    'safari': 7,
    'opera': 27,
    'ie': 11,
    'ms-edge': 12
  },
  excelMaps: {
    deviceConfig: {
      'serienummer,serienummer,serinummer,serienr,serialnr,serinenummer,serineummer,serirnummer,serienumer,seirenummer,sereinummer,serialnumber,serial number': 'SerialNumber',
      'förnamn,ownerfirstname,ägare,firstname,first name': 'OwnerFirstName',
      'efternamn,ownerlastname,lastname,surname': 'OwnerLastName',
      'mail,email,e-mail,owneremail,e-post,epost': 'OwnerEmail',
      'personnummer,ägar-id,person nummer,person nr,ägarens personnummer,ownersocialsecuritynumber,social security number': 'OwnerSocialSecurityNumber',
      'klass,class': 'OwnerClass',
      'taggar,tags,etiketter,etikett,customertag,customer tags': 'Tags',
      'avdelning,department,skola,school,enhet,unit': 'Unit',
      'grupp,group,kommun,Grupp / Kommun': 'GroupName',
      'image,computerimage,computer image,datorimage': 'ComputerImage',
      'nr,dator nr.,nummer,datornamn,computerNumber,datornummer,computernumber,Computer number': 'ComputerNumber',
      'Dator ID,datorid,asset,mölndals etikett,assettag,asset tag,computerid,karlskoga märkning,computerid,anton,Computer ID': 'ComputerId',
      'imei,aiport,wlan,airport,airPort id,airportid': 'AirPortId',
      'Stöldskyddsnummer,stöldskydd,stölsdkydd,syremærkning,stöldskyddsmärkning,stöldskydd,stöldmärkning,theftid,antitheftmarking,Anti-theft marking,Theft mark': 'AntiTheftMarking',
      'ethernet,ethernet id,mac,mac-adress,ethernetid,Macadress,ehternet': 'EthernetId',
      'bluetooth,bluetooth id,bluetoothid,bluetoothid': 'BluetoothId',
      'GoogleCustomerId,googleCustomerId,Googlekund-id,googlekund-id': 'GoogleCustomerId',
      'Notes,Anteckningar': 'Notes',
    },
    deviceInfo: {
      'serienummer,serienummer,serinummer,serienr,serialnr,serinenummer,serineummer,serirnummer,serienumer,seirenummer,sereinummer,serialnumber,serial number': 'SerialNumber',
      'förnamn,ownerfirstname,ägare,firstname,first name': 'OwnerFirstName',
      'efternamn,ownerlastname,lastname,surname': 'OwnerLastName',
      'mail,email,e-mail,owneremail,e-post,epost': 'OwnerEmail',
      'personnummer,ägar-id,person nummer,person nr,ägarens personnummer,ownersocialsecuritynumber,social security number': 'OwnerSocialSecurityNumber',
      'klass,class': 'OwnerClass',
      'taggar,tags,etiketter,etikett,customertag,customer tags': 'Tags',
      'avdelning,department,skola,school,enhet,unit,Unit': 'UnitName',
      'grupp,group,kommun,Grupp / Kommun': 'GroupName',
      'image,computerimage,computer image,datorimage': 'ComputerImage',
      'nr,dator nr.,nummer,datornamn,computerNumber,datornummer,computernumber,Computer number': 'ComputerNumber',
      'Dator ID,datorid,asset,mölndals etikett,assettag,asset tag,computerid,karlskoga märkning,computerid,anton,Computer ID': 'ComputerId',
      'imei,aiport,wlan,airport,airPort id,airportid,airport id': 'AirPortId',
      'Stöldskyddsnummer,stöldskydd,stölsdkydd,syremærkning,stöldskyddsmärkning,stöldskydd,stöldmärkning,theftid,antitheftmarking,Anti-theft marking,Theft mark': 'AntiTheftMarking',
      'ethernet,ethernet id,mac,mac-adress,ethernetid,Macadress,ehternet': 'EthernetId',
      'bluetooth,bluetooth id,bluetoothid,bluetoothid': 'BluetoothId'
    },
    massChangeDeviceInfo: {
      'serienummer,serienummer,serinummer,serienr,serialnr,serinenummer,serineummer,serirnummer,serienumer,seirenummer,sereinummer,serialnumber,serial number': 'SerialNumber',
      'förnamn,ownerfirstname,ägare,firstname,first name': 'OwnerFirstName',
      'efternamn,ownerlastname,lastname,surname': 'OwnerLastName',
      'mail,email,e-mail,owneremail,e-post,epost': 'OwnerEmail',
      'personnummer,ägar-id,person nummer,person nr,ägarens personnummer,ownersocialsecuritynumber,social security number': 'OwnerSocialSecurityNumber',
      'klass,class': 'OwnerClass',
      'taggar,tags,etiketter,etikett,customertag,customer tags': 'Tags',
      'avdelning,department,skola,school,enhet,unit,Unit': 'Unit',
      'grupp,group,kommun,Grupp / Kommun': 'GroupName',
      'image,computerimage,computer image,datorimage': 'ComputerImage',
      'nr,dator nr.,nummer,datornamn,computerNumber,datornummer,computernumber,Computer number': 'ComputerNumber',
      'Dator ID,datorid,asset,mölndals etikett,assettag,asset tag,computerid,karlskoga märkning,computerid,anton,Computer ID,dator-id': 'ComputerId',
      'imei,aiport,wlan,airport,airPort id,airportid,airport id': 'AirPortId',
      'Stöldskyddsnummer,stöldskydd,stölsdkydd,syremærkning,stöldskyddsmärkning,stöldskydd,stöldmärkning,theftid,antitheftmarking,Anti-theft marking,Theft mark': 'AntiTheftMarking',
      'ethernet,ethernet id,mac,mac-adress,ethernetid,Macadress,ehternet': 'EthernetId',
      'bluetooth,bluetooth id,bluetoothid,bluetoothid': 'BluetoothId',
      'GoogleCustomerId,googleCustomerId,Googlekund-id,googlekund-id': 'GoogleCustomerId'
    },
    deviceImport: {
      'serienummer,serienummer,serinummer,serienr,serialnr,serinenummer,serineummer,serirnummer,serienumer,seirenummer,sereinummer,serialnumber': 'SerialNumber',
      'unitid,enhetsid': 'UnitId',
      'avdelning,department,skola,school,enhet,unit': 'UnitName',
      'grupp,group,kommun,Grupp / Kommun': 'GroupName',
      'produktnummer,prdukt,product,product number,model,modell': 'ProductNumber',
      'förnamn,ownerfirstname,ägare,firstname': 'OwnerFirstName',
      'efternamn,ownerlastname,lastname': 'OwnerLastName',
      'mail,email,e-mail,owneremail,e-post,epost': 'OwnerEmail',
      'personnummer,ägar-id,person nummer,person nr,ägarens personnummer,ownersocialsecuritynumber,social security number': 'OwnerSocialSecurityNumber',
      'ComputerImage,image,datorimage,computer image': 'ComputerImage',
      'nr,dator nr.,nummer,datornamn,computerNumber,datornummer,computernumber': 'ComputerNumber',
      'Dator ID,datorid,asset,mölndals etikett,assettag,asset tag,computerid,karlskoga märkning,computerid,anton': 'ComputerId',
      'imei,aiport,wlan,airport,airPort id,airportid': 'AirPortId',
      'Stöldskyddsnummer,stöldskydd,stölsdkydd,syremærkning,stöldskyddsmärkning,stöldskydd,stöldmärkning,theftid,antitheftmarking,Theft mark': 'AntiTheftMarking',
      'ethernet,ethernet id,mac,mac-adress,ethernetid,Macadress,ehternet': 'EthernetId',
      'bluetooth,bluetooth id,bluetoothid,bluetoothid': 'BluetoothId'
    },
    userInvite: {
      'mail,email,e-mail,owneremail,e-post,epost,användare': 'Email',
      'grupp,group,kommun,Grupp / Kommun': 'GroupName',
      'avdelning,department,skola,school,enhet,unit': 'UnitName',
      'roll,role,rolltyp,roletype': 'RoleType'
    },
    nameList: {
      'förnamn,ownerfirstname,ägare,firstname': 'FirstName',
      'efternamn,ownerlastname,lastname': 'LastName',
      'mail,email,e-mail,owneremail,e-post,epost': 'Email',
      'personnummer,ägar-id,person nummer,person nr,ägarens personnummer,ownersocialsecuritynumber,social security number': 'SocialSecurityNumber',
      'klass,class': 'Class',
      'Stöldskyddsnummer,stöldskydd,stölsdkydd,syremærkning,stöldskyddsmärkning,stöldskydd,stöldmärkning,theftid,antitheftmarking,skanningsnummer,scan number,Theft mark': 'AntiTheftMarking',
      'Dator ID,datorid,asset,mölndals etikett,assettag,asset tag,computerid,karlskoga märkning,computerid,anton': 'ComputerId',
      'taggar,tags,etiketter,etikett,customertag,customer tags': 'Tags'
    },
    sparePartInventoryControl: {
      'SparePartId': 'SparePartId',
      'InventoryStockId': 'InventoryStockId',
      'SparePartNumber': 'SparePartNumber',
      'Description': 'Description',
      'OldStock': 'OldStock',
      'Stock': 'Stock',
      'MinimumStock': 'MinimumStock',
      'Shelf': 'Shelf'
    },
    sparePartSetPrices: {
      'SparePartId': 'SparePartId',
      'SparePartNumber': 'SparePartNumber',
      'Description': 'Description',
      'Notes': 'Notes',
      'Cost': 'Cost',
      'CostSetDate': 'CostSetDate'
    },
    sparePart: {
      'SparePartNumber,Reservdelsnummer': 'SparePartNumber',
      'Description,Beskrivning': 'Description',
      'Notes,Anteckningar': 'Notes',
      'Cost,Kostnad': 'Cost',
      'CostSetDate,Datum (Kostnad)': 'CostSetDate',
      'SparePartSupplierNumber,Leverantör': 'SparePartSupplierNumber',
      'ArticleNumber,Reparationstyp': 'ArticleNumber',
      'CompatibleModels,Kompatibla modeller': 'CompatibleModels'
    },
    sparePartOrder: {
      'ExternalOrderNumber': 'ExternalOrderNumber',
      'CaseNumber': 'CaseNumber',
      'SparePartNumber': 'SparePartNumber',
      'Quantity': 'Quantity',
      'Notes': 'Notes',
      'OrderLineType': 'OrderLineType'
    },
    replaceReport: {
      'ItemGroup': 'ItemGroup',
      'ProductName': 'ProductNumber',
      'Identifier': 'SerialNumber',
      'Quantity': 'Quantity',
      'FairMarketValue': 'Price'
    },
    gepZte: {
      'SerialNumber': 'SerialNumber',
      'GepCustomerId': 'GepCustomerId',
      'Description': 'Description',
      'Domain': 'Domain',
      'AttestedDeviceId': 'AttestedDeviceId',
      'PreProvisioningToken': 'PreProvisioningToken',
      'HardwareModel': 'HardwareModel'
    },
    gepDeprovision: {
      'SerialNumber': 'SerialNumber'
    },
    matrixItem: {
      'ProductNumber,Produktnummer': 'ProductNumber',
      'CustomerBuyoutPrice,Kundpris': 'CustomerBuyoutPrice'
    }
  },
  helpCenter: [
    {
      title: 'CONTACT_INFORMATION',
      sectionComponent: 'contact',
      youtubeIds: [],
      lin: true,
      customer: true,
      isOpen: false
    },
    {
      title: 'CONCEPT_EXPLANATIONS',
      sectionComponent: 'concept',
      youtubeIds: [],
      lin: true,
      customer: true,
      isOpen: false
    },
    {
      title: 'SEARCH',
      sectionComponent: 'search',
      youtubeIds: [],
      lin: true,
      customer: true,
      isOpen: false
    },
    {
      title: 'DELIVERY',
      sectionComponent: '',
      youtubeIds: [
        'KWDaPJU2rTg',
        'xHdBZQL-Lqk',
        'X9vY8gryBd0',
        'JdFPDd3FQO8'
      ],
      lin: false,
      customer: true,
      isOpen: false
    },
    {
      title: 'RECYCLE',
      sectionComponent: 'recycle',
      youtubeIds: ['IfaT_AiuSeQ'],
      lin: false,
      customer: true,
      isOpen: false
    },
    {
      title: 'SUPPORT_ISSUE_REGISTER',
      sectionComponent: 'supportissue',
      youtubeIds: [],
      lin: true,
      customer: true,
      isOpen: false
    },
    {
      title: 'CASEHANDLING',
      sectionComponent: 'casehandling',
      youtubeIds: [],
      lin: true,
      customer: true,
      isOpen: false
    },
    {
      title: 'TAGS',
      sectionComponent: 'tags',
      youtubeIds: [],
      lin: true,
      customer: false,
      isOpen: false
    },
  ],
  chartColors: {
    green: '#18c15a',
    darkGreen: '#15b152',
    orange: '#ec952d',
    darkOrange: '#bf7b25',
    red: '#ff4612',
    pink: '#ef3fa9',
    darkPink: '#a70064',
    purple: '#420070',
    blue: '#40b4e5',
    darkBlue: '#005cb9',
    grey: '#727F92',
    white : '#ffffff',
    yellow: '#ffc627',
    darkYellow: '#CC9300'
  },
  insuranceRejectionMessage: '\n\nOm du är missnöjd med beslutet, kontakta Foxway Education för information och förklaring till beslutet. Du kan även ge oss kompletterande uppgifter så kan vi göra en omprövning av beslutet.\n\nDet görs bäst genom att skriva i kommunikationen här i ärendet. Det går även bra att maila oss på lina@foxway.com. Du kan också överklaga beslutet till försäkringsbolaget.\n\nÖverklagan görs till AmTrust Nordic AB och skickas skriftligen till:\n\nAmTrust Insurance Services Sweden, Linnégatan 14, 114 47  Stockholm eller till skador@amtrustgroup.com. Märk överklagandet med ditt skadenummer Märk överklagandet med ditt skadenummer.\n\nDen som inte godtar AmTrust beslut i ärendet kan få ärendet prövat av:Allmänna Reklamationsnämnden (ARN). Prövningen är kostnadsfri och beslutet är av en rekommendation. Adress: Box 174, 101 23 Stockholm, telefon: 08-508 860 00 Allmän Domstol.\n\nKontakta din närmaste tingsrätt för ytterligare information. Om Du vill veta mer kan Du kontakta AmTrust eller ta kontakt med Konsumenternas försäkringsbyrå, Byrån gör ingen prövning av enskilda ärenden men ger kostnadsfritt råd och hjälp åt konsumenter i försäkringsfrågor.',
  insuranceTermsMessage: 'Enligt försäkringsbolagets villkor täcks ett ärende av försäkringen om skadan uppstått genom en plötslig och oförutsedd utifrån kommande händelse. Verktyget måste även ha hanterats med normal aktsamhet, alltså att det hanterats så att skada så långt som möjligt kunnat undvikas och rimliga försiktighetsåtgärder har vidtagits i förhållande till verktygets känslighet, hållbarhet och värde. För vår bedömning behöver vi en konkret skadehändelse, att ärendet anmälts inom 12 månader från skadetillfället samt att vi fått all relevant information inom två månader från anmälningstillfället.\n\nDå dessa krav uppfyllts i detta ärende gör vi bedömningen att försäkringen täcker 100% av kostnaden för reparation/ utbyte / lösen. Detta under förutsättning att den skadehändelse som angivits stämmer med de skador vår tekniker hittar vid felsökning på verkstaden.',
  insuranceTermsMessage5050: 'Enligt försäkringsbolagets villkor täcks ett ärende av försäkringen om skadan uppstått genom en plötslig och oförutsedd utifrån kommande händelse. Verktyget måste även ha hanterats med normal aktsamhet, alltså att det hanterats så att skada så långt som möjligt kunnat undvikas och rimliga försiktighetsåtgärder har vidtagits i förhållande till verktygets känslighet, hållbarhet och värde. För vår bedömning behöver vi en konkret skadehändelse, att ärendet anmälts inom 12 månader från skadetillfället samt att vi fått all relevant information inom två månader från anmälningstillfället.\n\nVi kan tyvärr inte reglera det här ärendet helt på försäkringen eftersom vi inte anser att eleven varit tillräckligt aktsam. Vi vill dock erbjuda en 50/50 lösning där försäkringen täcker halva kostnaden och andra halvan faktureras skolan. När verktyget felsökts på vår verkstad kommer vi publicera ett kostnadsförslag för denna lösning. Det kommer finnas under "Åtgärder".',
  insuranceTheftTermsMessage: 'Enligt försäkringsbolagets villkor täcks ett ärende av försäkringen om stölden skett i samband med rån/överfall eller inbrott. Rån/överfall avser att verktyget ryckts från användaren eller att någon/några med våld eller hot om våld tillskansat sig verktyget. Stölden måste ha uppfattats av användaren. Ett inbrott måste vara styrk, det vill säga att det finns fysiska tecken på att det skett. Verktyget får inte ha lämnats utan tillsyn i skollokal, på allmän plats eller i fordon. För vår bedömning behöver vi en konkret stöldhändelse, att ärendet anmälts inom 12 månader från skadetillfället samt att vi fått all relevant information inom två månader från anmälningstillfället. Detta inkluderar polisrapport.\n\nDå dessa krav uppfyllts i detta ärende gör vi bedömningen att försäkringen täcker 100% av kostnaden för ersättningsverktyg.'
};
